import { render } from "./widget.vue?vue&type=template&id=0ebb9877&scoped=true&ts=true&lang=pug"
import script from "./widget.vue?vue&type=script&lang=ts&setup=true"
export * from "./widget.vue?vue&type=script&lang=ts&setup=true"

import "./widget.vue?vue&type=style&index=0&id=0ebb9877&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ebb9877"]])

export default __exports__